<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333333;
  
}

body{
	margin: 0;
  padding: 0;
  box-sizing: border-box;
  background-color: #f4f4f4;
}

*{
	margin: 0;
	padding: 0;
	 box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue